module.exports = __webpack_public_path__ + "7f7f53624f69685f4c73f754cb316d35.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C00000Y7T.png
// module id = 1471
// module chunks = 0